
import { Vue, Component } from 'vue-property-decorator';
import ChangePasswordForm from '@/features/auth/components/changePassword/ChangePasswordForm.vue';
import NavLogo from '@/features/common/components/navbar/NavLogo.vue';

@Component({
  components: {
    ChangePasswordForm,
    NavLogo,
  },
})
export default class SetPassword extends Vue {
  private errorMessage = '';

  private created(): void {
    this.$store.commit('setLoading', false);
  }
}
